<!-- MaterialSymbolsIcon.vue -->
<script lang="ts" setup>
import { computed, onBeforeMount } from 'vue';
import { IconTypes } from '../../Enums/UiEnums';
import { assertInternally } from '../../lib/Environment';

    const props = defineProps<{
        icon?: IconTypes,
    }>();

    onBeforeMount(()=>{
        // TODO: We should pull this into a repository we control to avoid Google changing something and us looking access
        const materialFontUrl = "https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:wght@400";

        const link = document.querySelector(`a[href='${materialFontUrl}']`);
        if (!link)
        {
            const link = document.createElement('link');
            link.href = materialFontUrl;
            link.rel = 'stylesheet';
            document.head.appendChild(link);            
        }
    });

    // TODO: Need to fill out the rest of the icon types.
    const icons: Record<IconTypes | string, string> = {
        [IconTypes.Download]: "download",
        [IconTypes.View]: "pageview"
    };

    const iconName = computed(() =>{
        if (!props.icon)
        {
            assertInternally(`MaterialSymbolsIcon lacks definition for ${props.icon}`);
            return;
        }

        return icons[props.icon];
    });
</script>

<style>
    .material-symbols-rounded{
        font-size: 1rem;
    }
</style>

<template>
    <span class="material-symbols-rounded">{{iconName}}</span>
</template>